// extracted by mini-css-extract-plugin
export default {"container":"ExhibitionsOverview_container__PzjaP"};